"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  title?: string;
  subtitle?: string;
  faqs?: FAQItem[];
}

export default function FAQ({
  title = "Welcome to the FAQ!",
  subtitle = "Everything You Need to Know About my process",
  faqs = []
}: FAQProps) {
  return (
    <section className="section-padding container flex flex-col gap-8 md:flex-row md:gap-16">
      <div className="flex max-w-md flex-col gap-6 md:gap-16">
        <h2 className="text-3xl">{title}</h2>
        <h3 className="text-2xl leading-8 md:text-4xl md:leading-14 lg:text-5xl">
          {subtitle}
        </h3>
      </div>

      <Accordion defaultValue="item-0" type="single" className="flex-1 min-w-0 space-y-8">
        {faqs.map((item, index) => (
          <AccordionItem key={index} value={`item-${index}`} className="px-4">
            <AccordionTrigger className="cursor-pointer text-xl font-normal hover:no-underline md:pb-6 md:text-3xl">
              {item.question}
            </AccordionTrigger>
            <AccordionContent className="text-base md:pb-6">
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
